module.exports = __webpack_public_path__ + "static/media/9.64b4021a.jpg";